/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AttributEinheit {

    OhneEinheit = 'OhneEinheit',

    Prozent = 'Prozent',

    Euro = 'Euro',

    Monate = 'Monate',

    Jahre = 'Jahre',

    Quadratmeter = 'Quadratmeter',

    Tage = 'Tage',

    TausendEuro = 'TausendEuro',

    MillionenEuro = 'MillionenEuro'
}

